export default {
  dateLocale: 'fr-CA',
  dateFormatOption: {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }
};